import { Outlet } from "react-router-dom";
import SmoothScroll from "../components/SmoothScroll";
import Footer from "./footer/footer";
import Header from "./header/header";

export default function Layout({ children }) {
    return (
        <div>
            <Header />
            <main>
                <SmoothScroll>
                    <Outlet />
                </SmoothScroll>
            </main>
            <Footer />
        </div>
    );
}